import { Injectable } from '@angular/core';
import { DispatchToExport, DispatchItemToExport } from '../models';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class DispatchToCustomerService {
  constructor(public apiService: ApiService) { }

  getDispatchZone(): Observable<any> {
    return this.apiService
      .get(`${this.apiService.dispatchToCustomer}`)
      .pipe(map(data => data));
  }

  filterDispatchToCustomer(requestDispatchToCustomer: any): Observable<any> {
    const api: string =   `${this.apiService.businessDispatchRead}/delivery`;
    return this.apiService
      .post(api, requestDispatchToCustomer)
      .pipe(map((data) => data));
  }

  saveDispatchToCustomer(tripRequest: any): Observable<any> {
    return this.apiService.put(this.apiService.dispatch + '/trip', tripRequest
    ).pipe(
      map(data => data)
    );
  }

  massiveTravelCreation(tripRequest: any): Observable<any> {
    return this.apiService.post(this.apiService.dispatch + '/trip/massive', tripRequest
    ).pipe(
      map(data => data)
    );
  }

  getLocationDispatchToClient(locationRequest: any): Observable<any> {
    const api: string = this.apiService.dispatchToLocation + '?limit=100&offset=0&' + locationRequest;
    return this.apiService.get(api).pipe(
      map(data => data)
    );
  }

  getLocationDispatchMassive(locationRequest: any): Observable<any[]> {
    const api: string = this.apiService.dispatchMassiveLocation;
    return this.apiService.post(api, locationRequest).pipe(
      map(data => data)
    );
  }

  getStateNVByCompany(listDispatch: any): Observable<any> {
    return this.apiService
      .post(
        `${this.apiService.orderPaymentRead}/order-payment/status`,
        listDispatch
      )
      .pipe(map((data) => data));
  }

  getAvailableDispatchHours(companyCode): Observable<any> {
    return this.apiService.get(`${this.apiService.dispatch}/timecuts/${companyCode}`).pipe(
      map(data => data)
    );
  }

  getDispatchesToExport(request:any): Observable<DispatchToExport[]> {
    const api = this.apiService.businessDispatchRead + "/delivery";
    return this.apiService.post(api, request).pipe(map((data) => data));
  }

  getDispatchItemsToExport(request:any): Observable<DispatchToExport[]> {
    const api = this.apiService.businessDispatchRead + "/delivery";
    return this.apiService.post(api, request).pipe(map((data) => data));
  }
}
